import AuthorizedLayout from '@/components/layouts/AuthorizedLayout.vue'
import DashboardLayout from '@/components/layouts/DashboardLayout.vue'
import UnauthorizedLayout from '@/components/layouts/UnauthorizedLayout.vue'
import { dashboardRoutes } from '@/router/dashboardRoutes'
import { routeNames } from '@/router/routeNames'
import { unauthorizedRoutes } from '@/router/unauthorizedRoutes'
import PathwayLandingView from '@/views/pathway/PathwayLandingView.vue'

import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/dashboard',
    component: DashboardLayout,
    meta: {
      auth: true,
    },
    children: dashboardRoutes,
  },
  {
    path: '/landing',
    name: routeNames.LandingPage,
    meta: { title: 'common.route.landingPage' },
    component: PathwayLandingView,
  },
  {
    path: '/',
    component: UnauthorizedLayout,
    children: unauthorizedRoutes,
  },
  {
    path: '/dashboard/workspace',
    component: AuthorizedLayout,
    children: [
      {
        meta: {
          auth: true,
          title: 'common.route.configuration',
        },
        path: '/dashboard/configuration/view/:id',
        name: routeNames.Configuration,
        component: () => import('@/views/ConfigurationView.vue'),
      },
      {
        meta: {
          auth: true,
          title: 'common.route.editor',
        },
        path: '/dashboard/configuration/:id/editor',
        name: routeNames.Editor,
        component: () => import('@/views/EditorView.vue'),
      },
      {
        meta: {
          auth: true,
          title: 'common.route.blockly',
        },
        path: '/dashboard/blockly/flow/:flowUuid/rule/:ruleUuid?',
        name: routeNames.Blockly,
        props: true,
        component: () => import('@/views/BlocklyView.vue'),
      },
    ],
  },
  {
    path: '/pathway/:flowUuid/:pathwayUuid?',
    name: routeNames.Pathway,
    meta: { title: 'common.route.pathway' },
    component: () => import('@/views/pathway/PathwayView.vue'),
  },
  {
    path: '/configuration-summary/:token',
    name: routeNames.ConfigurationSummary,
    meta: { title: 'common.route.configurationsSummary' },
    component: () => import('@/views/FinishedConfigurationUserView.vue'),
    props: true,
  },
  {
    path: '/:pathMatch(.*)*',
    meta: { title: 'common.notFound' },
    component: () => import('@/views/NotFoundView.vue'),
  },
]
